<template>  
  <div v-if="section_residue_visible">
    <span class="title">Click one or more residues to see available {{ SecTitle }}: </span> 
    <button class="selectAll" type="button" v-on:click="check_all_thing"> Select All </button> 
    <div class="cardList">
      <residueCard v-on:click_checkbox = "click_checkbox"
        v-for               = "(card, index) in residueData"
        v-bind:key          = "index"
        v-bind:imgUrl       = "card.url"
        v-bind:residueName  = "card.name"
        v-bind:count        = "card.count" 
        v-bind:checked      = "card.checked" /> 
    </div> 
    <hr /> 
  </div>  
</template>  
 
<script>  
import residueCard from './residueCard.vue'; 

export default {
  name: 'residueSection',  
  props: ['SecTitle', 'residueData', 'section_residue_visible'],
  methods: { 
    click_checkbox: function (cardName) { 
      this.$emit('click_checkbox', cardName);
    },

    check_all_thing: function () { 
      this.$emit('check_all_thing', 'checkbox_residue'); 
    }
  },
  components: {
    residueCard
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>  
  .cardList {
    display: flex;
    flex-direction: row; 
    flex-wrap: wrap;
  } 
  .selectAll {
    font-size: 1.5em;
    font-weight: bold;
  }
  .title {
    font-size: 2em;
    font-weight: bold;
  }
</style>
